import { ScrollingModule } from '@angular/cdk/scrolling';
import { NgModule } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { MatInputModule } from '@angular/material/input';
import { MatMenuModule } from '@angular/material/menu';
import { MatTooltipModule } from '@angular/material/tooltip';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import {
    piIconHourglassBold,
    piIconJobBriefcase,
    piIconReferenceProfileAdapter,
    piIconReferenceProfileAltruist,
    piIconReferenceProfileAnalyzer,
    piIconReferenceProfileArtisan,
    piIconReferenceProfileCaptain,
    piIconReferenceProfileCollaborator,
    piIconReferenceProfileController,
    piIconReferenceProfileCraftsman,
    piIconReferenceProfileGuardian,
    piIconReferenceProfileIndividualist,
    piIconReferenceProfileMaverick,
    piIconReferenceProfileOperator,
    piIconReferenceProfilePersuader,
    piIconReferenceProfilePromoter,
    piIconReferenceProfileScholar,
    piIconReferenceProfileSpecialist,
    piIconReferenceProfileStrategist,
    piIconReferenceProfileVenturer,
    piIconSearchBold
} from '@predictiveindex/pi-client-icons';
import {
    TapestryDropdownModule,
    TapestryIconButtonModule,
    TapestryIconModule,
    TapestryIconRegistryService
} from '@predictiveindex/tapestry';
import { TranslationsModule } from '../../../translations';
import { DirectivesModule } from '../../Directives';
import { GlobalSearchMenuComponent } from './global-search-menu.component';
@NgModule({
    declarations: [GlobalSearchMenuComponent],
    exports: [GlobalSearchMenuComponent],
    imports: [
        MatMenuModule,
        TapestryIconButtonModule,
        TapestryIconModule,
        TapestryDropdownModule,
        FormsModule,
        BrowserAnimationsModule,
        ScrollingModule,
        MatInputModule,
        TranslationsModule,
        DirectivesModule,
        MatTooltipModule
    ]
})
export class GlobalSearchMenuModule {
    constructor(private iconRegistryService: TapestryIconRegistryService) {
        this.iconRegistryService.registerIcons([
            piIconSearchBold,
            piIconHourglassBold,
            piIconJobBriefcase,
            piIconReferenceProfileAdapter,
            piIconReferenceProfileAltruist,
            piIconReferenceProfileAnalyzer,
            piIconReferenceProfileArtisan,
            piIconReferenceProfileCaptain,
            piIconReferenceProfileCollaborator,
            piIconReferenceProfileController,
            piIconReferenceProfileCraftsman,
            piIconReferenceProfileGuardian,
            piIconReferenceProfileIndividualist,
            piIconReferenceProfileMaverick,
            piIconReferenceProfileOperator,
            piIconReferenceProfilePersuader,
            piIconReferenceProfilePromoter,
            piIconReferenceProfileScholar,
            piIconReferenceProfileSpecialist,
            piIconReferenceProfileStrategist,
            piIconReferenceProfileVenturer
        ]);
    }
}
